import React, { ReactElement } from 'react'
import { Layout } from 'antd';
const { Content } = Layout;
import HeaderMenu from './HeaderMenu'

// import SideBarMenu from './SideBarMenu'
export enum notifyType {
  CANXACNHANBAOGIA = 'CANXACNHANBAOGIA',
  COTHAYDOIBAOGIA = 'COTHAYDOIBAOGIA',
  COYEUCAUMUA = 'COYEUCAUMUA',
  COYEUCAUTACH = 'COYEUCAUTACH',
  COYEUCAUTHANHTOAN = 'COYEUCAUTHANHTOAN',
}

interface Props {
  children: ReactElement
}
const BasicLayout: React.FC<Props> = ({ children }) => {
  
  return (
    <Layout
      className="basic-layout"
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* <SideBarMenu/> */}
      <HeaderMenu />

      <Layout
        className="site-layout"
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Content
          className="site-layout-background"
          style={{
            flex: 1,
            minHeight: 0,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            margin: 0,
            padding: 0,
          }}
        >
          <div className="basic-layout-content">{children}</div>
        </Content>
      </Layout>
    </Layout>
  )
}

export default BasicLayout
